module.exports = __webpack_public_path__ + "img/header-background.adc325c5.svg";